
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[brandSlug]",
      function () {
        return require("private-next-pages/brands/[brandSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[brandSlug]"])
      });
    }
  